import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: white;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const IllustrationSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border-right: 1px solid #eef1f6;

  /* Same treatment as the homepage hero diagram column: warm radial
     gradient + faint orange grid, so the live hub-spoke diagram reads as
     one continuous piece of branding across Login and the homepage. */
  background: radial-gradient(120% 100% at 50% 45%, #fff4ec 0%, #fffbf8 45%, #ffffff 100%);

  @media (max-width: 768px) {
    display: none;
  }
`;

export const IllustrationScaler = styled.div`
  position: relative;
  z-index: 1;
  transform: scale(0.88);

  @media (max-width: 1200px) {
    transform: scale(0.68);
  }

  @media (max-width: 900px) {
    transform: scale(0.51);
  }
`;

export const IllustrationCaption = styled.div`
  position: absolute;
  z-index: 1;
  bottom: 52px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 11px 20px;
  border-radius: 999px;
  background: #fef0e7;
  color: #c94e0c;
  font-family: 'Archivo', 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
`;

export const FormSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: white;
  position: relative;
  z-index: 1;
  max-width: 50%; /* Ensure equal split on large screens */
  
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
  
  img {
    height: 50px;
    margin-bottom: 1rem;
  }
`;

export const WelcomeText = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #1E293B;
  margin: 0;
  text-align: center;
`;



export const OptionsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #64748B;
  cursor: pointer;
  font-size: 0.9rem;

  input {
    accent-color: #F97316;
    width: 16px;
    height: 16px;
  }
`;

export const ForgotPasswordLink = styled.a`
  color: #F97316;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    text-decoration: underline;
  }
`;

export const ErrorText = styled.span`
  color: #EF4444;
  font-size: 0.85rem;
  font-weight: 600;
  margin-top: 0.25rem;
  display: block;
`;

export const SignUpText = styled.p`
  text-align: center;
  color: #64748B;
  font-size: 0.95rem;
  margin-top: 1rem;

  span {
    color: #F97316;
    font-weight: 600;
    cursor: pointer;
    margin-left: 0.25rem;

    &:hover {
      text-decoration: underline;
    }
  }
`;
